import FinancialReport from "./FinancialReport";

export default FinancialReport;
